import { AgentOptions } from '@newrelic/browser-agent/loaders/agent';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

import config from 'app.config';

/**
 * All values are public and safe to use in the browser.
 */
const ACCOUNT_ID = 1950551;
const LICENSE_KEY = '696a09ea8f';
const DATA_COLLECTION_DOMAIN = 'bam.nr-data.net';

const getOptions = (applicationId: number): AgentOptions => ({
  info: {
    applicationID: String(applicationId),
    beacon: DATA_COLLECTION_DOMAIN,
    errorBeacon: DATA_COLLECTION_DOMAIN,
    licenseKey: LICENSE_KEY,
    sa: 1,
  },
  init: {
    ajax: {
      deny_list: [
        DATA_COLLECTION_DOMAIN,
      ],
    },
    browser_consent_mode: {
      enabled: false,
    },
    distributed_tracing: {
      enabled: true,
    },
    performance: {
      capture_detail: false,
      capture_marks: false,
      capture_measures: true,
    },
    privacy: {
      cookies_enabled: true,
    },
  },
  loader_config: {
    accountID: ACCOUNT_ID,
    agentID: applicationId,
    applicationID: applicationId,
    licenseKey: LICENSE_KEY,
    trustKey: ACCOUNT_ID,
  },
});

let agent: BrowserAgent | undefined;

export const NewRelic = {

  /**
   * Instantiates the New Relic browser agent.
   */
  initialize: (): BrowserAgent | undefined => {
    if (agent) {
      return agent;
    }

    if (!config.NEW_RELIC_APPLICATION_ID) {
      return;
    }

    agent = new BrowserAgent(getOptions(config.NEW_RELIC_APPLICATION_ID));

    return agent;
  },

};
